interface DesignTokens {
  [key: string]: string | Tokens;
}

interface Tokens {
  [key: string]: string | Tokens;
}

export const convertTokens = (tokens: Tokens, designTokens: DesignTokens): Tokens => {
  const traverseAndReplace = (obj: Tokens): Tokens => Object.keys(obj).reduce((acc, key) => {
      const value = obj[key];

      if (typeof value === 'string' && value.startsWith('var(--')) {
        const tokenKey = value.replace(/^var\(\-\-|\)$/g, ''); 
        acc[key] = designTokens[tokenKey] || value;
      } else if (typeof value === 'object' && value !== null) {
        acc[key] = traverseAndReplace(value);
      } else {
        acc[key] = value;
      }

      return acc;
    }, {} as Tokens);

  return traverseAndReplace(tokens);
};